module.exports = __webpack_public_path__ + "static/media/s7logo.d6845fd3.png";